import { createSlice } from "@reduxjs/toolkit";
import * as selectors from "./selectors";
import {
  EventState,
  SetEditEventDialogToImage,
  SetIsCreateEventDialogOpenAction,
  SetEditEventDialogStateAction,
} from "./interfaces";
import * as extraActions from "../../extra-actions";
import * as sagas from "./sagas";

const initialState: EventState = {
  isCreateEventDialogOpen: false,
  editEventDialogState: {
    isOpen: false,
    editMode: false,
    editImage: false,
    selectedEvent: null,
  },
  list: [],
  singleUseEvent: null,
};

export const eventStore = createSlice({
  name: "event",
  initialState,
  reducers: {
    setIsCreateEventDialogOpen: (
      state,
      action: SetIsCreateEventDialogOpenAction,
    ) => {
      state.isCreateEventDialogOpen = action.payload;
    },
    setEditEventDialogToImage: (state, action: SetEditEventDialogToImage) => {
      state.editEventDialogState.editImage = action.payload;
    },
    setEditEventDialogState: (state, action: SetEditEventDialogStateAction) => {
      if (!state.editEventDialogState) {
        state.editEventDialogState = {
          isOpen: false,
          editMode: false,
          editImage: false,
          selectedEvent: null,
        };
      }
      state.editEventDialogState = {
        editImage: action.payload.editImage ?? false,
        ...action.payload,
      };
    },
    resetSingleUseEvent: (state) => {
      state.singleUseEvent = initialState.singleUseEvent;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      extraActions.getMerchantsEventsByMerchantId.success,
      (state, action) => {
        state.list = action.payload.data.events;
      },
    );
    builder.addCase(
      extraActions.postMerchantsEventsByMerchantId.success,
      (state, action) => {
        state.list = state.list ?? [];
        state.list.push(action.payload.data.event);
      },
    );
    builder.addCase(
      extraActions.patchMerchantsEventsByMerchantIdAndEventId.success,
      (state, action) => {
        state.list = state.list.map((el) =>
          el._id === action.payload.data.event._id
            ? action.payload.data.event
            : el,
        );
      },
    );
    builder.addCase(
      extraActions.getMerchantsSingleUseEventsByMerchantId.success,
      (state, action) => {
        state.singleUseEvent = action.payload.data.singleUseEvent;
      },
    );
    builder.addCase(
      extraActions.patchSingleUseEventsBySingleUseEventId.success,
      (state, action) => {
        state.singleUseEvent = action.payload.data.singleUseEvent;
      },
    );
    builder.addCase(extraActions.appStartup, (state) => {
      state.isCreateEventDialogOpen = initialState.isCreateEventDialogOpen;
      state.editEventDialogState = initialState.editEventDialogState;
      state.singleUseEvent = initialState.singleUseEvent;
    });
    builder.addCase(extraActions.clearSession, (state, action) => {
      Object.assign(state, initialState);
    });
  },
});

export { selectors, sagas };
